import React from 'react';
import { motion } from 'framer-motion';
import { FaExclamationTriangle } from 'react-icons/fa';
import SEO from './SEO';
import './ErrorBoundary.css';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    // You can also log the error to an error reporting service here
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <>
          <SEO 
            title="Error - Student Helper"
            description="An error occurred while loading the page."
            keywords="error, student helper error, page error"
          />
          <div className="error-boundary">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="error-content"
            >
              <FaExclamationTriangle className="error-icon" />
              <h1>Oops! Something went wrong</h1>
              <p>We're sorry, but there was an error loading this page.</p>
              <button 
                className="retry-button"
                onClick={() => window.location.reload()}
              >
                Try Again
              </button>
              {process.env.NODE_ENV === 'development' && (
                <div className="error-details">
                  <h2>Error Details:</h2>
                  <pre>{this.state.error && this.state.error.toString()}</pre>
                  <pre>{this.state.errorInfo && this.state.errorInfo.componentStack}</pre>
                </div>
              )}
            </motion.div>
          </div>
        </>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 